import { useTranslation } from 'react-i18next';

import { TextField } from '@rootsight/ui';

/**
 * CodeField is the box a second-factor code is typed into. An authenticator
 * code is marked one-time-code with a numeric keyboard, so a phone offers the
 * code from an app or a message; a recovery code is plain text and is never
 * autofilled.
 */
export function CodeField({
  kind,
  value,
  onChange,
}: {
  kind: 'totp' | 'recovery';
  value: string;
  onChange: (value: string) => void;
}) {
  const { t } = useTranslation('auth');
  return kind === 'totp' ? (
    <TextField
      key="totp"
      label={t('login.mfa.code')}
      name="code"
      value={value}
      onChange={onChange}
      autoComplete="one-time-code"
      inputMode="numeric"
      maxLength={8}
      isRequired
      autoFocus
    />
  ) : (
    <TextField
      key="recovery"
      label={t('login.mfa.recoveryCode')}
      name="recovery-code"
      value={value}
      onChange={onChange}
      autoComplete="off"
      placeholder="abcde-fghjk"
      maxLength={16}
      isRequired
      autoFocus
    />
  );
}
